export var RESULT_PROPERTY_NAME = 'result';
export var ORDER_OPTIONS = [{
  label: RESULT_PROPERTY_NAME,
  value: RESULT_PROPERTY_NAME
}];
export var DIRECTION_LABELS = {
  ASC: 'Ascending',
  DESC: 'Descending'
};
export var DIRECTION_OPTIONS = [{
  label: 'DESC',
  value: 'DESC'
}, {
  label: 'ASC',
  value: 'ASC'
}];
export var DEFAULT_ORDER_SETTINGS = {
  propertyName: RESULT_PROPERTY_NAME,
  direction: 'ASC'
};
export var DRAG_ANIMATION_TIME = 100;